var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-width:1.5px;}.cls-1{stroke-linejoin:bevel;fill-rule:evenodd;}.cls-2{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-contact-edit-contact"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-1",
    d: "M22,12.27v4.37a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V7.36a2,2,0,0,1,2-2h6.76"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "cls-2",
    d: "M19.3,4.25a1,1,0,0,0-1.42,0l-6,6h0l-.1,3a.21.21,0,0,0,.23.22l3-.1h0l6-6A1,1,0,0,0,21,6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEdit);
export default __webpack_public_path__ + "static/media/contact-edit.dee9ff1540bd40139d5b8fc3fb5d6d5b.svg";
export { ForwardRef as ReactComponent };